import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
function AttachFileVertical(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.875L6 5.25C6 3.5925 7.3425 2.25 9 2.25C10.6575 2.25 12 3.5925 12 5.25L12 14.625C12 15.66 11.16 16.5 10.125 16.5C9.09 16.5 8.25 15.66 8.25 14.625L8.25 6.75C8.25 6.3375 8.5875 6 9 6C9.4125 6 9.75 6.3375 9.75 6.75L9.75 13.875L10.875 13.875L10.875 6.75C10.875 5.715 10.035 4.875 9 4.875C7.965 4.875 7.125 5.715 7.125 6.75L7.125 14.625C7.125 16.2825 8.4675 17.625 10.125 17.625C11.7825 17.625 13.125 16.2825 13.125 14.625L13.125 5.25C13.125 2.97 11.28 1.125 9 1.125C6.72 1.125 4.875 2.97 4.875 5.25L4.875 13.875L6 13.875Z",
    fill: color
  }));
}
export default AttachFileVertical;